class Registration {
    constructor() {
        const registrationCustom = document.querySelectorAll('.js-registration');
        registrationCustom.forEach((item) => {
            Registration.bindChanges(item);
        });
        const eyeballs = document.querySelectorAll('.js-eyeball');
        eyeballs.forEach((item) => {
            Registration.bindTogglePassword(item);
        });
    }

    static bindChanges(item) {
        if (!item.dataset.values && !item.dataset.dependance) {
            return;
        }
        item.addEventListener('change', () => {
            const values = item.dataset.values.split(',');
            const dependance = document.getElementById(item.dataset.dependance);
            if (dependance) {
                const span = document.createElement('span');
                span.innerHTML = ' *';
                span.classList.add('required-fields');

                dependance.required = values.includes(item.value);

                if (dependance.parentNode.querySelector('label span')) {
                    dependance.parentNode.querySelector('label span').remove();
                }

                if (values.includes(item.value)) {
                    dependance.parentNode.querySelector('label').append(span);
                }
            }
        });
    }

    static bindTogglePassword(item) {
        const input = item.parentNode.querySelector('input');
        item.addEventListener('click', () => {
            if (input.getAttribute('type') === 'password') {
                input.setAttribute('type', 'text');
            } else {
                input.setAttribute('type', 'password');
            }
        });
    }
}

export default Registration;
